import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { TableButton } from "components/ui";
import FaFileExcelO from "react-icons/lib/fa/file-excel-o";
import { put } from "utils/api";
import { errorMessage } from "actions/message";

const TableControls = ({ query }) => {
  const dispatch = useDispatch();

const transformQueryToIndexParams = (query) => {
  // Transform filters object to filter_by array
  const filterMap = {};
  
  if (query.filters) {
    Object.entries(query.filters).forEach(([key, values]) => {
      if (Array.isArray(values) && values.length > 0) {
        // Filter out empty values and join with ^
        const validValues = values.filter(v => v);
        if (validValues.length > 0) {
          filterMap[key] = validValues.join("^");
        }
      }
    });
  }

  // Convert map to filter_by array
  const filterBy = Object.entries(filterMap).map(([key, value]) => ({
    by: key,
    value: value
  }));

  return {
    search_for_array: [],
    pagination: query.pagination,
    sort: query.sort,
    filter_by: filterBy
  };
  };

  const handleExport = async () => {
    try {
      const payload = transformQueryToIndexParams(query);
      await put("incomplete_order_tracking/export", payload);
    } catch (error) {
      dispatch(errorMessage("Failed to export orders"));
    }
  };

  return (
    <div className="query-table-controls">
      <TableButton
        title="Export orders to excel file"
        onClick={handleExport}
      >
        <FaFileExcelO />
      </TableButton>
    </div>
  );
};

export default TableControls;

TableControls.propTypes = {
  query: PropTypes.object.isRequired
};